export enum SWEET_ALERT {
  SHOW = 'SWEET_ALERT_SHOW',
  CLOSE = 'SWEET_ALERT_CLOSE'
}
